var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8299 5.50341L15.7122 10.3235V7.29182C10.046 7.31189 9.09254 9.51401 8.32275 11.2919C8.23866 11.4861 8.15676 11.6753 8.07114 11.856C8.07114 5.65776 12.0489 3.6562 15.7122 3.62818V0.68335L21.8299 5.50341ZM8.67676 1.65879H6.03315C3.07975 1.65879 0.685547 4.05299 0.685547 7.00639V14.5932C0.685547 17.5466 3.07975 19.9408 6.03315 19.9408H13.6199C16.5733 19.9408 18.9675 17.5466 18.9675 14.5932V11.7181H16.1155V14.5932C16.1155 15.9714 14.9982 17.0887 13.6199 17.0887H6.03315C4.6549 17.0887 3.5376 15.9714 3.5376 14.5932V7.00639C3.5376 5.62814 4.6549 4.51084 6.03315 4.51084H8.67676V1.65879Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.031f9b3f24fc15620c9a33759a3f2458.svg";
export { ForwardRef as ReactComponent };